export default __webpack_public_path__ + "static/media/Selected_Task.b46595eb.svg";